<template>
  <div class="dp-ag-grid-selection-filter">
    <select class="dp-ag-grid-selection-select dp-ag-grid-input-pad" v-model="correlation" @change="updateFilter">
      <option v-for="cor in corres" :key="cor.value" :value="cor.value">{{ cor.name }}</option></select
    ><br />
    <select class="dp-ag-grid-selection-select" v-model="choice" @change="updateFilter">
      <option value=""></option>
      <option v-for="option in options" :key="option.value" :value="option.value">{{ option.name }}</option>
    </select>
  </div>
</template>

<style scoped>
.dp-ag-grid-selection-filter {
  padding: 12px 12px 6px 12px;
}
.dp-ag-grid-selection-select {
  border: solid 1px #bbb;
  border-radius: 5px;
  height: 30px;
  min-width: 135px;
  outline: none;
  appearance: auto;
  -moz-appearance: auto;
  -webkit-appearance: auto;
}
.dp-ag-grid-selection-filter:focus {
  box-shadow: 0 0 2px 0.1rem rgb(33 150 243 / 40%);
}
.dp-ag-grid-input-pad {
  margin: 0px 0px 6px 0px;
}
</style>

<script>
// import Vue from "vue";
import VueJS from "vue/dist/vue.js";

export default VueJS.extend({
  data: function () {
    return {
      choice: "",
      options: [],
      corres: [
        { name: "一致", value: 1 },
        { name: "除外", value: 2 },
      ],
      correlation: 1,
    };
  },
  mounted: function () {
    const nameKey = this.params.nameKey || "text";
    const valueKey = this.params.valueKey || "value";
    const options = [];
    this.params.options.forEach((option) => {
      if (typeof option === "object") {
        options.push({ name: option[nameKey], value: option[valueKey] });
      } else {
        options.push({ name: option, value: option });
      }
    });
    this.options = options;
  },
  methods: {
    updateFilter() {
      this.params.filterChangedCallback();
    },
    isFilterActive() {
      return this.choice !== "";
    },
    doesFilterPass(params) {
      if (this.correlation == 1) {
        const colId = this.params.column.colId;
        return params.data[colId] === this.choice;
      } else if (this.correlation == 2) {
        const colId = this.params.column.colId;
        return params.data[colId] !== this.choice;
      }
      return true;
    },
    getModel() {
      return { value: this.choice };
    },
    setModel(model) {
      this.choice = model ? model.value : "";
    },
  },
});
</script>
